<template>  
  <transition :name="transitionEffect">
    <div 
      v-if="currentSlide"
      class="slide-item absolute top-0 right-auto w-full max-h-full"
      :class="sliderHeight"
    >
      <img 
        :src="publicPath+slide.image"
        :alt="slide.name"
        class=" min-w-full h-full object-cover"
      />
      <div>{{ slide.name }}</div>
    </div>
  </transition>
</template>
<script>

export default {
    props: {
      currentSlide: {
        type: Boolean,
        requiered: false,
        default: false
      }, 
      slide: {
        type: Object,
        requiered: false,
        default: null
      },
      transitionEffect: {
        type: String,
        requiered: false,
        default: ''
      },
      publicPath: {
        type: [Object,String],
        requiered: false,
        default: process.env.BASE_URL
      },
      sliderHeight: {
        type: String,
        requiered: false,
        default: 'h-full'
      }
    },
    data() {
      return {
          // publicPath: process.env.BASE_URL
      };
    },
    mounted() {
      //console.log(this.slide)
    }
}
</script>

<style scoped>

  .slide-in-enter-active,
  .slide-in-leave-active {
    transition: all 4s ease-in-out;
  }
  .slide-in-enter-from {
    transform: translateX(100%);
  }
  .slide-in-leave-to {
    transform: translateX(-100%)
  }

  .slide-out-enter-active,
  .slide-out-leave-active {
    transition: all 4s ease-in-out;
  }
  .slide-out-enter-from {
    transform: translateX(-100%);
  }
  .slide-out-leave-to {
    transform: translateX(100%);
  }

  .slide-item.h92{
    height: 92%;
  } 

  .slide-item.h85{
    height: 85%;
  } 

 @media screen and (min-width: 640px) {
  .slide-item.sm-h92 {
    height: 92%;
  }
 }

 @media screen and (min-width:768px) {
  .md-buttons-aside .slide-in-enter-active,
  .md-buttons-aside .slide-in-leave-active{
    transition: all 2s ease-in;
  }

  .md-buttons-aside .slide-out-enter-active,
  .md-buttons-aside .slide-out-leave-active {
    transition: all 2s ease-in;
  }

  .md-buttons-aside .slide-in-enter-from {
    opacity: 0;
  }

  .md-buttons-aside .slide-in-leave-to {
    opacity: 1;
  }

  .md-buttons-aside .slide-out-enter-from {
    opacity: 1;
  }
  .md-buttons-aside .slide-out-leave-to {
    opacity: 0;
  }

   .md-buttons-aside .slide-item {
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    /* md:left-1/2 md:transform md:-translate-x-1/2 md:w-4/5 */
  } 
} 
</style>